import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <div className=''>
    </div>
  );
};

export default Footer;